import Gateway from '../service/gateway'
import RequestUtils from '../utils/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getportalpages(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.getportalpages(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getportalpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.getportalpage(payload), {
        type: 'info',
        success,
        fail
      })
    },
    publishhomepage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.publishhomepage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    publishportalpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.publishportalpage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteportalpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.deleteportalpage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addportalpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.addportalpage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateportalpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.updateportalpage(payload), {
        type: 'action',
        success,
        fail
      })
    },

    gettagscanscenes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.gettagscanscenes(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gettagscanscene(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.gettagscanscene(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addtagscanscene(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.addtagscanscene(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatetagscanscene(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.updatetagscanscene(payload), {
        type: 'action',
        success,
        fail
      })
    },
    settagscansceneproducts(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Gateway.settagscansceneproducts(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
